import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./modal-reject-krookie.module.scss";
import errorIcon from "../../../../../images/error-120.svg";
import Button from "../../../../ui-kit/button/button";
import Modal from "../../../../../shared/modal/modal";
import { useAppSelector } from "../../../../../hooks/useAppSelector";

interface ModalRejectKrookieProps {
  onClose: () => void;
  onClickViewChanges: () => void;
}

const ModalRejectKrookie: FC<ModalRejectKrookieProps> = ({
  onClose,
  onClickViewChanges,
}) => {
  const { convertedKrookieData } = useAppSelector(
    (state) => state.masterPlanModification,
  );

  const { t } = useTranslation();

  const krookies = Object.values(convertedKrookieData.krookies);

  const plotNumbers = krookies.map((krookie) => krookie.plotNumber);
  const plotNumberDisplay = plotNumbers.join(", ");

  let rejectedMessage;
  if (krookies.length > 1) {
    rejectedMessage = t("modalRejectKrookie.rejectionMessageMultiple");
  } else {
    rejectedMessage = t("modalRejectKrookie.rejectionMessage", {
      serial: krookies[0].serial,
    });
  }

  return (
    <Modal onClose={onClose}>
      <div className={styles.modalSuccessful}>
        <div className={styles.title}>
          {t("modalRejectKrookie.plotNumber")}: {plotNumberDisplay}
        </div>
        <div className={styles.body}>
          <img src={errorIcon} alt={t("modalRejectKrookie.errorAlt")} />
          <div className={styles.description}>{rejectedMessage}</div>
          <Button
            onClick={onClickViewChanges}
            className={styles.btn}
            type="primary"
          >
            {t("modalRejectKrookie.viewJournalButton")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalRejectKrookie;
